import {
  GoogleAuthProvider,
  signInWithPopup,
  OAuthProvider,
  signInWithEmailAndPassword,
  sendPasswordResetEmail,
} from "@firebase/auth";
import { auth } from "shared/config/firebase";
import { resetAllStores } from "shared/store/store";
import { ApiRoutes } from "./apiRoutes";
import RestService from "./RestService";
import { UserService } from "./UserService";

const join = async () => {
  try {
    await UserService.getMe();
  } catch (error) {
    if (error.status === 401) {
      await RestService.post(ApiRoutes.JOIN, {});
    }
  }
};

export const AuthService = {
  signInWithGoogle: async () => {
    const googleProvider = new GoogleAuthProvider();
    googleProvider.setCustomParameters({
      prompt: "select_account",
    });

    await signInWithPopup(auth, googleProvider);
    await join();
  },

  signInWithApple: async () => {
    const provider = new OAuthProvider("apple.com");
    await signInWithPopup(auth, provider);
    await join();
  },

  signInWithMicrosoft: async () => {
    const provider = new OAuthProvider("microsoft.com");

    await signInWithPopup(auth, provider);
    await join();
  },

  signInWithEmailAndPassword: async (email: string, password: string) => {
    const formattedEmail = email.trim().toLowerCase();
    if (!formattedEmail) throw Error("Invalid email");
    if (!password) throw Error("Invalid password");

    const credentials = await signInWithEmailAndPassword(
      auth,
      formattedEmail,
      password,
    );

    await join();

    return credentials;
  },

  passwordReset: async (email: string) => {
    const formattedEmail = email.trim().toLowerCase();
    return await sendPasswordResetEmail(auth, formattedEmail);
  },

  signOut: async () => {
    resetAllStores();
    await auth.signOut();
  },
};
